import { jsxs as s, jsx as r } from "react/jsx-runtime";
import { useState as B } from "react";
const V = (n) => "options" in n, E = (n) => {
  const {
    name: g,
    id: a,
    placeholder: $,
    label: b,
    reference: N,
    callback: d,
    data: t,
    error: w,
    message: u,
    helpText: v,
    disabled: f,
    className: x,
    testId: e
  } = n, [y, D] = B(""), m = a ? `${a}-error-help` : void 0, i = !!w, c = i && !!u, p = !!v, F = c || p, S = (l) => {
    const o = l.target.value;
    D(o), d == null || d(o);
  };
  return /* @__PURE__ */ s(
    "div",
    {
      className: `Dropdown-group ${x}`,
      "data-testid": e ? `${e}-group` : void 0,
      children: [
        /* @__PURE__ */ r(
          "label",
          {
            className: "Form-label",
            htmlFor: a,
            "data-testid": e ? `${e}-label` : void 0,
            children: b
          }
        ),
        /* @__PURE__ */ r(
          "div",
          {
            className: ["Dropdown", i ? "Dropdown--error" : ""].filter(Boolean).join(" "),
            "data-testid": e ? `${e}-container` : void 0,
            children: /* @__PURE__ */ s(
              "select",
              {
                className: "Dropdown-menu",
                id: a,
                name: g,
                ref: N,
                value: y,
                onChange: S,
                disabled: f,
                "aria-invalid": i ? "true" : void 0,
                "aria-describedby": F ? m : void 0,
                "data-testid": e ? `${e}-select` : void 0,
                children: [
                  /* @__PURE__ */ r("option", { value: "", children: $ || "Select" }),
                  t == null ? void 0 : t.map((l, o) => V(l) ? /* @__PURE__ */ r(
                    "optgroup",
                    {
                      label: l.label,
                      children: l.options.map((h) => /* @__PURE__ */ r("option", { value: h.key, children: h.value }, h.key))
                    },
                    `group-${l.label}-${o}`
                  ) : /* @__PURE__ */ r("option", { value: l.key, children: l.value }, l.key))
                ]
              }
            )
          }
        ),
        (c || p) && /* @__PURE__ */ s(
          "ul",
          {
            id: m,
            "data-testid": e ? `${e}-help-list` : void 0,
            children: [
              c && /* @__PURE__ */ s(
                "li",
                {
                  className: "Form-help Form-help--error",
                  "data-testid": e ? `${e}-message` : void 0,
                  children: [
                    /* @__PURE__ */ r(
                      "span",
                      {
                        "data-testid": e ? `${e}-warning` : void 0,
                        "aria-hidden": "true",
                        children: "warning"
                      }
                    ),
                    /* @__PURE__ */ r("span", { className: "u-hiddenVisually", children: "Error," }),
                    /* @__PURE__ */ r("span", { children: u })
                  ]
                }
              ),
              p && /* @__PURE__ */ r("li", { className: "Form-help", children: v })
            ]
          }
        )
      ]
    }
  );
};
export {
  E as Dropdown
};
//# sourceMappingURL=Dropdown.mjs.map
